import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import vueAxios from 'vue-axios';
import vueNextSelect from 'vue-next-select';
import 'vue-next-select/dist/index.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@invisiburu/vue-picker/dist/vue-picker.min.css';
import FloatingVue from 'floating-vue';
import Popper from 'vue3-popper';
import vueCookies from 'vue3-cookies';
// import toaster from "@meforma/vue-toaster";
// const toasterConfig = {
//     position: "bottom",
//     duration:7000,
// };
import Toast from 'vue3-toast-single';
import 'vue3-toast-single/dist/toast.css';
import WorkspaceHeader from '@/components/shared/WorkspaceHeader.vue';
import ReloadPage from '@/components/shared/ReloadPage.vue';
import './sass/app.scss';
import 'floating-vue/dist/style.css'

// Font Awesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faLock, faTimes, faChevronUp, faChevronDown, faCheckSquare, faStepForward, faVolumeUp, faVolumeOff, faCaretRight, faCaretDown, faFile, faPaste, faInfoCircle, faEllipsisH, faRandom, faPlay, faPause, faPlusCircle, faCircle, faMinusCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// //Load base JSON
import cwJSON from './assets/json/cw.json';

library.add(faLock, faTimes, faChevronUp, faChevronDown, faCheckSquare, faStepForward, faVolumeUp, faVolumeOff, faCaretRight, faCaretDown, faFile, faPaste, faInfoCircle, faEllipsisH, faRandom, faPlay, faPause, faPlusCircle, faCircle, faMinusCircle);

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// axios.defaults.headers.Authorization = 'Bearer '+ localStorage.getItem('si_access_token');

axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('si_access_token')) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('si_access_token')}`;
    }

    config.headers.Accept = 'application/json';
    config.headers['Content-Language'] = 'en-us';
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    return config;
  },
  (err) => {
    console.log(`Failure: ${err}`);
    // return Promise.reject(err);
  },
);

const app = createApp(App);
app.use(vueAxios, axios);
app.config.globalProperties.axios = axios;
app.use(FloatingVue);
app.use(vueCookies);
app.use(router);
app.use(Toast, { verticalPosition: 'bottom', duration: 6000, className: ['cw-toast'] });
// app.use(toaster, toasterConfig)
app.use(Popper);
app.component('vue-select', vueNextSelect);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('WorkspaceHeader', WorkspaceHeader);
app.component('reload-page', ReloadPage);
app.provide('cwGlobal', cwJSON);

app.mount('#app');
